/* eslint-disable max-len */

export default {
  pricesSortingDisabledMessageLine1: '21022019-105513-0021',
  pricesSortingDisabledMessageLine2: '21022019-105513-0043'
};
